import type { ReactNode } from 'react';

import { CommandPaletteProvider } from '@/app/surfaces/command-palette-provider.js';
import { FormDrawerProvider } from '@/app/surfaces/form-drawer-provider.js';
import { QuickPanelProvider } from '@/app/surfaces/quick-panel-provider.js';

interface SurfaceProvidersProps {
  children: ReactNode;
}

/** Form drawer → quick panel → command palette (inner can use outer contexts). */
export function SurfaceProviders({ children }: SurfaceProvidersProps) {
  return (
    <FormDrawerProvider>
      <QuickPanelProvider>
        <CommandPaletteProvider>{children}</CommandPaletteProvider>
      </QuickPanelProvider>
    </FormDrawerProvider>
  );
}
